/**
 * 結果コード（例：AX-K3F7-Q2）— 設計書 §7.3
 * 匿名の回答データにのみ紐づく。個人情報とは一切紐づかない。
 * 紛らわしい文字（0/O, 1/I, etc.）を除いたCrockford風の英数字。
 */
const ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
function randomInts(len) {
    // Node/ブラウザ双方で使える範囲でセキュアな乱数を優先
    const g = typeof globalThis !== "undefined" ? globalThis : {};
    if (g.crypto && typeof g.crypto.getRandomValues === "function") {
        const buf = new Uint32Array(len);
        g.crypto.getRandomValues(buf);
        return Array.from(buf);
    }
    return Array.from({ length: len }, () => Math.floor(Math.random() * 0xffffffff));
}
export function generateResultCode() {
    const nums = randomInts(6);
    const chars = nums.map((n) => ALPHABET[n % ALPHABET.length]);
    return `AX-${chars.slice(0, 4).join("")}-${chars.slice(4, 6).join("")}`;
}
const CODE_RE = /^AX-[A-HJ-NP-Z2-9]{4}-[A-HJ-NP-Z2-9]{2}$/;
export function isValidResultCode(code) {
    return CODE_RE.test(code);
}
//# sourceMappingURL=resultCode.js.map